export const blockIconsPhotoandimageImageNew = (
	<span className='material-symbols-outlined'>image</span>
);
